import dev from './dev'
import product from './product'
import staging from './staging'

export default function getConfig() {
  if (process.env.VUE_APP_ENV === 'production') {
    return product
  }
  if (process.env.VUE_APP_ENV === 'staging') {
    return staging
  }

  return dev
}
